import { render, staticRenderFns } from "./WatchOurSeminars.vue?vue&type=template&id=752b3d60&scoped=true&"
import script from "./WatchOurSeminars.js?vue&type=script&lang=js&"
export * from "./WatchOurSeminars.js?vue&type=script&lang=js&"
import style0 from "./WatchOurSeminars.vue?vue&type=style&index=0&id=752b3d60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b3d60",
  null
  
)

export default component.exports